import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useSelector,useDispatch } from "react-redux";

const DynamicTable = ({ data }) => {
  const allSafetyMarginNull = data.every((row) => !row.scenarioSafetyMarginType);

  const allSafetyMarginTypes = allSafetyMarginNull
    ? []
    : [
        ...new Set(
          data
            .flatMap((row) =>
              row.scenarioSafetyMarginType?.map((item) => item.type) || []
            ),
        ),
      ];

  return (
    <TableContainer component={Paper} sx={{marginTop:2}}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              rowSpan={2}
              sx={{
                backgroundColor: "grey.lighter",
                borderRight: "1px solid white",
                color: "white",
              }}
            >
              Hierarchy
            </TableCell>
            <TableCell
              rowSpan={2}
              sx={{
                backgroundColor: "grey.lighter",
                borderRight: "1px solid white",
                color: "white",
              }}
            >
              Scenario Name
            </TableCell>
            <TableCell
              rowSpan={2}
              sx={{
                backgroundColor: "grey.lighter",
                borderRight: "1px solid white",
                color: "white",
              }}
            >
              Data Source Name
            </TableCell>
            <TableCell
              colSpan={2}
              sx={{
                backgroundColor: "grey.lighter",
                borderRight: "1px solid white",
                textAlign: "center",
                color: "white",
              }}
            >
              Customer Breakdown
            </TableCell>
            <TableCell 
              rowSpan={2} 
              sx={{ 
                backgroundColor: "grey.lighter", 
                borderRight: "1px solid white", 
                color: "white" 
                }}
              >
                Minimum Quota
            </TableCell>
            <TableCell
            rowSpan={allSafetyMarginTypes.length > 0 ? 1:2}
              colSpan={allSafetyMarginTypes.length > 0 ? allSafetyMarginTypes.length : 1}
              sx={{
                backgroundColor: "grey.lighter",
                textAlign: "center",
                borderRight: "1px solid white",
                color: "white",
              }}
            >
              Safety Margin (%)
            </TableCell>
            <TableCell
              rowSpan={2}
              sx={{
                backgroundColor: "grey.lighter",
                borderRight: "1px solid white",
                color: "white",
              }}
            >
              Period Type
            </TableCell>
            <TableCell
              rowSpan={2}
              sx={{
                backgroundColor: "grey.lighter",
                color: "white",
              }}
            >
              Comments
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                backgroundColor: "grey.lighter",
                borderRight: "1px solid white",
                color: "white",
              }}
            >
              Methodology
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "grey.lighter",
                borderRight: "1px solid white",
                color: "white",
              }}
            >
              Period
            </TableCell>
            {allSafetyMarginTypes.length > 0 &&
              allSafetyMarginTypes.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    backgroundColor: "grey.lighter",
                    borderRight:
                      index === allSafetyMarginTypes.length - 1
                        ? "1px solid white"
                        : "1px solid white",
                       color: "white",
                  }}
                >
                  {header}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => {
            const isSafetyMarginNull = !row.scenarioSafetyMarginType;
            return (
              <TableRow key={rowIndex}>
                <TableCell sx={{ borderRight: "1px solid white" }}>
                  {row.hierarchy}
                </TableCell>
                <TableCell sx={{ borderRight: "1px solid white" }}>
                  {row.scenarioName}
                </TableCell>
                <TableCell sx={{ borderRight: "1px solid white" }}>
                  {row.dataSourceName}
                </TableCell>
                <TableCell sx={{ borderRight: "1px solid white" }}>
                  {row.customerBreakdownType}
                </TableCell>
                <TableCell sx={{ borderRight: "1px solid white" }}>
                  {row.customerBreakdown}
                </TableCell>
                <TableCell sx={{ textAlign:"center",borderRight: "1px solid white" }}>
                {row.minimumQuota ? parseFloat(row.minimumQuota) : ""}
                </TableCell>
                {allSafetyMarginTypes.length > 0
                  ? allSafetyMarginTypes.map((header, index) => {
                      const margin = isSafetyMarginNull
                        ? 0
                        : Math.floor(row.scenarioSafetyMarginType?.find(
                            (item) => item.type === header
                          )?.safetyMargin ||0);

                      return (
                        <TableCell
                          key={index}
                          sx={{
                            textAlign:"center",
                            borderRight:
                              index === allSafetyMarginTypes.length - 1
                                ? "1px solid white"
                                : "1px solid white",
                          }}
                        >
                          {margin || 0} 
                        </TableCell>
                      );
                    })
                  : (
                    <TableCell sx={{ textAlign:"center",borderRight: "1px solid white" }}>0</TableCell>
                  )}
                <TableCell sx={{ borderRight: "1px solid white" }}>
                  {row.periodType}
                </TableCell>
                <TableCell>{row.comments}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};


export default function DataGridScenario() {
  const state = useSelector((store) => store.analyze);
	const { 
			scenarioOtherInfoData,
      selectedScenarios
	 } 
		= state;
    
    const filteredData=scenarioOtherInfoData?.filter(row=>selectedScenarios.includes(row.scenarioID));
    //console.log("The filtered data is",filteredData);
  return <DynamicTable data={filteredData} />;
}
